var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"189dc8fcc8ab455d14c658f177b3ac2efbe56fc5"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["yapdomik-frontend-website@sushi-market"]={id:"189dc8fcc8ab455d14c658f177b3ac2efbe56fc5"};
      